// Brandprofil for hentpost.dk.
//
// Vaerdierne her er kopieret ord for ord fra koden foer brand-laget blev
// indfoert. Aendrer du en streng her, aendrer du hentposts udadvendte tekst —
// gør det bevidst.

const domain = 'hentpost.dk';

module.exports = {
    key: 'hentpost',
    name: 'HentPost',
    // Den anden instans, selskaber kan spejles med. Navnet hoerer i
    // brand-laget: staar det i en komponent, laekker det til det andet brand.
    partner_navn: 'DigitalBox',
    domain,
    // Bilagsindbakkens domaene. Skal matche mail_domain i backend/brand.py.
    mailDomain: domain,

    // Brandets egen adminkonto. Bruges kun til at vise handlinger, som
    // backenden alligevel forbeholder netop den konto — se
    // _er_brandets_admin i server.py. Frontenden afgoer intet selv.
    adminEmail: 'admin@hentpost.dk',

    // Ordmaerket vises som to dele, hvor anden del baerer brandfarven
    wordmark: { lead: 'Hent', tail: 'Post' },

    // Den foldbare indbakke og den moerke sidebar. DigitalBox har
    // 'tre-kolonner' — se brand/digitalbox.js.
    appDesign: 'klassisk',

    // Metatags
    title: 'HentPost – Digital post direkte i indbakken',
    description: 'HentPost – Modtag al din virksomheds digitale post direkte i indbakken. Automatisk videresendelse fra Virk, E-Boks og MIT.dk.',
    ogDescription: 'Modtag al din virksomheds digitale post fra Virk, E-Boks og MIT.dk direkte på email. Automatisk videresendelse til kolleger og revisor.',
    twitterDescription: 'Modtag al din virksomheds digitale post fra Virk, E-Boks og MIT.dk direkte på email.',
    themeColor: '#0A0E17',

    // Kontakt og ejerskab
    supportEmail: 'support@capexconnect.dk',
    ownerLine: 'HentPost.dk er en service leveret af Sundahl ApS',
    copyrightName: 'HentPost',

    // Digital Post-opsaetning som den vises for kunden
    digitalPost: {
        systemName: 'HentPost',
        // Kontaktoplysningerne kunden skriver ind hos e-Boks. Adressen staar
        // for sig selv: app@ er ogsaa vores afsenderadresse, og de to
        // behoever ikke vaere ens — paa DigitalBox er de det ikke.
        contactEmail: 'app@hentpost.dk',
        contactPhone: '77111222',
        // Den konto kunden giver systemfuldmagt til i Digital Post. Skal matche
        // det CVR, vores mTLS-certifikat er udstedt til — ellers afvises alt
        // med 403. Staar ogsaa i backend/brand.py; de to SKAL vaere enige.
        operatorName: 'CapexConnect ApS',
        operatorCvr: '34491402',
    },

    // Standardmappe i OneDrive/Dropbox/Google Drive
    cloudFolder: 'HentPost',

    // Bundle-siden: hvilket produkt kunden allerede har
    bundle: { ownProduct: 'HentPost', ownPrice: '49 kr' },
};
